import React, { useState } from "react";
import "./FAQs.css";
import {
  Arrow1,
  Arrow2,
  FaqImage,
  Step1,
  Step2,
  Step3,
  StepImage,
  StepImage2,
  StepImage3,
  WalletImage,
} from "../../Assets";
import Fade from "react-reveal/Fade";
import Zoom from "react-reveal/Zoom";
const allData = [
  {
    id: 1,
    answer:
      "Welcome to AlphaSwap, your one-stop-shop for all things blockchain. We are a team of experts dedicated to bringing you the latest news, insights, and solutions for your blockchain needs. Blockchain technology is revolutionizing the world, and we want to make sure that you are ahead of the game",
    question: "What is AlphaSwap?",
  },
  {
    id: 2,
    answer:
      "Welcome to AlphaSwap, your one-stop-shop for all things blockchain. We are a team of experts dedicated to bringing you the latest news, insights, and solutions for your blockchain needs. Blockchain technology is revolutionizing the world, and we want to make sure that you are ahead of the game",
    question: "How do I use AlphaSwap?",
  },
  {
    id: 3,
    answer:
      "Welcome to AlphaSwap, your one-stop-shop for all things blockchain. We are a team of experts dedicated to bringing you the latest news, insights, and solutions for your blockchain needs. Blockchain technology is revolutionizing the world, and we want to make sure that you are ahead of the game",
    question: "What are the transaction fees for AlphaSwap?",
  },
  {
    id: 4,
    answer:
      "Welcome to AlphaSwap, your one-stop-shop for all things blockchain. We are a team of experts dedicated to bringing you the latest news, insights, and solutions for your blockchain needs. Blockchain technology is revolutionizing the world, and we want to make sure that you are ahead of the game",
    question: "Lorem Ipsum is simply dummy text of the printing?",
  },
  {
    id: 5,
    answer:
      "Welcome to AlphaSwap, your one-stop-shop for all things blockchain. We are a team of experts dedicated to bringing you the latest news, insights, and solutions for your blockchain needs. Blockchain technology is revolutionizing the world, and we want to make sure that you are ahead of the game",
    question: "Is my wallet and transaction information secure on AlphaSwap?",
  },
  {
    id: 6,
    answer:
      "Welcome to AlphaSwap, your one-stop-shop for all things blockchain. We are a team of experts dedicated to bringing you the latest news, insights, and solutions for your blockchain needs. Blockchain technology is revolutionizing the world, and we want to make sure that you are ahead of the game",
    question: "What tokens are supported on AlphaSwap?",
  },
];

const FAQs = () => {
  const [isSelected, setIsSelected] = useState(1);
  return (
    <>
      <Fade top>
        <p className="Faq_Section_Text_Style">FAQ Section</p>
      </Fade>
      <section className="Faq_Main_Container" id="Faq_Section">
        <div className="Faq_Question_Main_Container">
          <Fade left>
            <div className="faq_Question_Wrapper">
              {allData.map((item, index) => {
                return (
                  <div
                    className="faq_Main_Text_Container"
                    style={{
                      backgroundColor:
                        isSelected == item.id ? "#132841" : "#091b32",
                    }}
                    onClick={() => {
                      if (isSelected == item.id) {
                        setIsSelected(null);
                      } else {
                        setIsSelected(item.id);
                      }
                    }}
                  >
                    <div className="faq_Text_Wrapper">
                      <p className="faq_id_Text_Style">{item.id}.</p>
                      <p className="faq_Question_Text_Style">{item.question}</p>
                    </div>
                    {isSelected == item.id ? (
                      <p className="faq_Answer_Text_Style">{item.answer}</p>
                    ) : null}
                  </div>
                );
              })}
            </div>
          </Fade>
          <Fade right>
            <div className="FaqImage_Container_Style">
              <img src={FaqImage} alt="FaqImage" className="faqImage_Style" />
            </div>
          </Fade>
        </div>
        <Zoom>
          <div className="Faq_Multi_Wallet_Container">
            <div className="Faq_Wallet_Text_Container">
              <p className="faq_Alpha_Multi_Wallet_Text_Style">
                ALPHA SWAP{"\n"}Pro Multi Wallets
              </p>
              <p className="faq_Alpha_Multi_Wallet_Des_Text_Style">
                Experience the next level of decentralized trading with
                ALPHASWAP Pro (Multi-wallet trading). Our platform allows you to
                purchase tokens with up to 3 wallets at once, making it easier
                and more convenient to execute trades. With the Multi-Wallet
                trading functionality of  ALPHASWAP Pro, you can swap tokens
                faster, safer, and with more efficiency.
              </p>
            </div>

            <div className="Faq_Wallter_Image_Style_Container">
              <img
                src={WalletImage}
                alt="Image"
                className="Faq_Wallet_Image_Style"
              />
            </div>
          </div>
        </Zoom>
        <Fade right>
          <p className="Faq_Work_TextStyle">Here's how it works</p>
        </Fade>
      </section>
      <Fade bottom>
        <section className="Faq_Main_Container_Section">
          <div className="Faq_Main_Work_Container">
            <div className="faq_LinearGradient_Wrapper1">
              <div className="Faq_Main_LinearGradient_Style">
                <img src={StepImage} alt="Image" className="step_Container" />
                <div lassName="Faq_Step_Image_Style_Container1">
                  <img
                    src={Step1}
                    alt="Image"
                    className="Faq_Step_Image_Style1"
                  />
                </div>
              </div>
              <p className="faq_Work_Text_Style">Connect Your Wallet</p>
              <p className="Faq_work_Des_Text_Style">
                Visit the dapp for ALPHASWAP Pro. 
              </p>
            </div>
            <div className="Faq_Arrow_Container">
              <img src={Arrow1} alt="Image" />
            </div>
            <div className="faq_LinearGradient_Wrapper">
              <div className="Faq_Main_LinearGradient_Style2">
                <img src={StepImage2} alt="Image" className="step_Container" />
                <div className="Faq_Step_Image_Style_Container">
                  <img
                    src={Step2}
                    alt="Image"
                    className="Faq_Step_Image_Style2"
                  />
                </div>
              </div>
              <p className="faq_Work_Text_Style">Add Private Keys</p>
              <p className="Faq_work_Des_Text_Style">
                Add the private keys (of your sub-wallets) to be able to make
                swaps with up to 3 wallets and execute transactions instantly.
                Our platform ensures that your private keys are encrypted and
                secure.
              </p>
            </div>
            <div className="Faq_Arrow_Container">
              <img src={Arrow2} alt="Image" />
            </div>
            <div className="faq_LinearGradient_Wrapper">
              <div className="Faq_Main_LinearGradient_Style3">
                <img src={StepImage3} alt="Image" className="step_Container" />
                <div className="Faq_Step_Image_Style_Container">
                  <img
                    src={Step3}
                    alt="Image"
                    className="Faq_Step_Image_Style3"
                  />
                </div>
              </div>
              <p className="faq_Work_Text_Style">Execute Trades!</p>
              <p className="Faq_work_Des_Text_Style">
                Make your swaps with advanced speed and safety features. Alpha
                Swap Pro allows you to execute trades instantly, giving you an
                advantage in the fast-paced world of cryptocurrency trading.
                With our platform, you can trade with confidence and security.
              </p>
            </div>
          </div>
        </section>
      </Fade>
    </>
  );
};

export default FAQs;
